import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const seller = async (id?: number) => axios.get(Routes.SELLER + "/" + id);

export const useSeller = (id?: number) =>
  useQuery({
    queryKey: [Keys.SELLER_QRY, id],
    queryFn: () => seller(id),
    enabled: id ? true : false,
  });
